import { sanitizeCSVValue } from 'src/utils/csvsecurity';
import * as XLSX from 'xlsx';

const sanitizeFileName = (fileName: string): string => {
  const trimmed = fileName.trim();
  const withoutExtension = trimmed.replace(/\.xlsx$/i, '');
  const sanitized = withoutExtension.replace(/[^\w\s-]/g, '').trim();

  return sanitized.length > 0 ? sanitized : 'dynamic-case-import-template';
};

export const downloadDynamicCaseImportTemplate = (
  headers: string[],
  fileName: string,
): void => {
  const sanitizedHeaders = headers.map((header) =>
    String(sanitizeCSVValue(header)),
  );
  const workbook = XLSX.utils.book_new();
  const sheet = XLSX.utils.aoa_to_sheet([sanitizedHeaders]);

  XLSX.utils.book_append_sheet(workbook, sheet, 'Template');
  XLSX.writeFile(workbook, `${sanitizeFileName(fileName)}.xlsx`, {
    bookType: 'xlsx',
  });
};
